export default __webpack_public_path__ + "static/media/virus.a81e0705.svg";